import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, BaseRouteReuseStrategy} from '@angular/router';

/**
 * The router's own reuse rules, except that a route gets a new component when its `id` changes. The router keeps a
 * route's component when only its parameters change, and the pages of one record (a project, its health view, a user)
 * read their id once, so a link to another record on the same route kept the old one on screen. The project page's
 * link warnings and the alert banner link to other projects (tasks 4.9, 4.10).
 */
@Injectable()
export class NewComponentPerIdStrategy extends BaseRouteReuseStrategy {
	override shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
		return super.shouldReuseRoute(future, current) && future.params['id'] === current.params['id'];
	}
}
